import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormChip } from "@/forms-design-system/FormChip";

export type AuctionBidBadge = "isWinning" | "isOutbid" | "won" | "lost";

interface AuctionBidBadgeChipProps {
  bidBadge: AuctionBidBadge;
}

const BADGE_CONFIG = {
  isWinning: { labelKey: "yourTopBidder", vibe: "positive" },
  isOutbid: { labelKey: "yourOutbid", vibe: "danger" },
  won: { labelKey: "yourWon", vibe: "positive" },
  lost: { labelKey: "yourLost", vibe: "danger" },
} as const;

export const AuctionBidBadgeChip: FC<AuctionBidBadgeChipProps> = ({ bidBadge }) => {
  const { t } = useTranslate();
  const config = BADGE_CONFIG[bidBadge];

  return (
    <FormChip
      label={t("ticketing", config.labelKey)}
      vibe={config.vibe}
      variant="outlined"
      sx={{ width: "fit-content" }}
    />
  );
};
